var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.text.text_investors_geography_title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "investors-geography"
  }, _vm._l((_vm.investorsGeographies.item), function(geography, key1) {
    return _c('div', {
      staticClass: "investors-geography__item"
    }, [_c('div', {
      staticClass: "investors-geography__item-img"
    }, [_c('img', {
      style: (("animation-delay: " + ((key1 * 100)/1000) + "s")),
      attrs: {
        "src": geography.photo.$src,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "investors-geography__item-percent"
    }, [_c('span', {
      staticClass: "percents",
      class: {
        'percents_double': String(geography.$percents).length > 1
      }
    }, [(String(geography.$percents)[0]) ? _c('span', {
      staticClass: "percents__line"
    }, _vm._l((_vm.rand), function(ind, key) {
      return (key >= parseInt(String(geography.$percents)[0], 10)) ? _c('span', {
        staticClass: "percents__num"
      }, [_vm._v("\n              " + _vm._s(key) + "\n            ")]) : _vm._e()
    })) : _vm._e(), _vm._v(" "), (String(geography.$percents)[1] > 0) ? _c('span', {
      staticClass: "percents__line"
    }, _vm._l((_vm.rand), function(ind2, key2) {
      return (_vm.rand.length - key2 >= parseInt(String(geography.$percents)[1], 10)) ? _c('span', {
        staticClass: "percents__num"
      }, [_vm._v("\n              " + _vm._s(_vm.rand.length - key2) + "\n            ")]) : _vm._e()
    })) : _c('span', {
      staticClass: "percents__line"
    }, [_c('span', {
      staticClass: "percents__num"
    }, [_vm._v("\n              " + _vm._s(String(geography.$percents)[1]) + "\n            ")])])]), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "investors-geography__item-title"
    }, [_vm._v(_vm._s(geography.text.item.title))])])
  })), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.text.text_investors_types_title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "investors-types",
    class: {
      'animated': _vm.typesAnimation
    }
  }, _vm._l((_vm.investorsTypes.item), function(type, key) {
    return _c('div', {
      staticClass: "investors-types__item"
    }, [_c('div', {
      staticClass: "investors-types__item-title"
    }, [_c('span', {
      style: (("animation-delay: " + ((key * 100)/1000) + "s"))
    }, [_vm._v("\n          " + _vm._s(type.text.item.title) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "investors-types__item-value",
      style: (("animation-delay: " + (((key + 1) * 170)/1000) + "s"))
    }, [_c('span', [_c('span', {
      style: ({
        width: type.$percents + '%'
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "investors-types__item-number"
    }, [_c('span', {
      style: (("animation-delay: " + (((key + 1) * 300)/1000) + "s"))
    }, [_vm._v(_vm._s(type.$percents) + "%")])])])
  }))])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "percents__sign"
  }, [_c('span', [_vm._v("%")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e047de38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Investors.vue
// module id = 211
// module chunks = 0